import { render, staticRenderFns } from "./TreehouseRepetitionModal.vue?vue&type=template&id=10242e88&scoped=true"
import script from "./TreehouseRepetitionModal.vue?vue&type=script&lang=js"
export * from "./TreehouseRepetitionModal.vue?vue&type=script&lang=js"
import style0 from "./TreehouseRepetitionModal.vue?vue&type=style&index=0&id=10242e88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10242e88",
  null
  
)

export default component.exports